import * as types from './mutation-types';

export default {
  canvasAddQuestion({ commit, state }, question) {
    commit(types.ADD_CANVAS_QUESTION, question);
    commit(types.SELECT_CANVAS_QUESTION_ID, question.id);
  },

  canvasSetQuestions({ commit, dispatch, state }, questions) {
    commit(types.SET_CANVAS_QUESTIONS, questions);
  },

  canvasAddChoice({ commit, getters, state }, choice) {
    const question = getters.canvasSelectedQuestion;
    if (question && state.choiceTypes.includes(question.questionType)) {
      const currentChoices = question.choices || [];
      const questions = state.canvasQuestions.map(q => {
        if (q.id !== question.id) {
          return q;
        }
        return { ...q, choices: [...currentChoices, choice] };
      });
      commit(types.SET_CANVAS_QUESTIONS, questions);
    }
  },
  canvasAddChoices({ dispatch }, choices) {
    choices.forEach(choice => dispatch('canvasAddChoice', choice));
  },
  canvasSelectQuestion({ commit, state, dispatch }, questionId) {
    commit(types.SELECT_CANVAS_QUESTION_ID, questionId);
    dispatch('getChoiceTemplates');
  },

  selectorSelectQuestionCategory({ commit }, categoryId) {
    commit(types.SELECT_SELECTOR_QUESTION_CATEGORY, categoryId);
  },
  selectorSelectTemplateId({ commit, dispatch }, templateId) {
    commit(types.SELECT_SELECTOR_TEMPLATE_ID, templateId);
    dispatch('getChoices');
  },
  selectorSelectTemplateCategory({ commit }, categoryId) {
    commit(types.SELECT_SELECTOR_TEMPLATE_CATEGORY, categoryId);
    commit(types.SELECT_SELECTOR_CHOICE_CATEGORY, categoryId);
  },
  selectorSelectChoiceCategory({ commit }, categoryId) {
    commit(types.SELECT_SELECTOR_CHOICE_CATEGORY, categoryId);
  },
  selectorSetTemplateSearchText({ commit }, text) {
    commit(types.SET_SELECTOR_TEMPLATE_TEXT, text);
  },
  selectorResetTemplateFilters({ commit }) {
    commit(types.RESET_SELECTOR_TEMPLATE_FILTERS);
    commit(types.RESET_SELECTOR_CHOICE_FILTERS);
  },

  questionDialogCancel({ commit }) {
    commit(types.SET_QUESTION_DIALOG_VISIBILITY, false);
    commit(types.SET_QUESTION_DIALOG_ADD_TO_CANVAS, false);
  },

  questionDialogCreate({ commit, dispatch }, question) {
    dispatch('createQuestion', question);

    commit(types.SET_QUESTION_DIALOG_VISIBILITY, false);
    commit(types.SET_QUESTION_DIALOG_ADD_TO_CANVAS, false);
  },

  questionDialogEdit({ commit, dispatch }, question) {
    dispatch('updateQuestion', question);

    commit(types.SET_QUESTION_DIALOG_VISIBILITY, false);
    commit(types.SET_QUESTION_DIALOG_ADD_TO_CANVAS, false);
  },

  choiceTemplateDialogCreate({ commit, dispatch }, template) {
    dispatch('createChoiceTemplate', template);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY, false);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE, false);
  },

  choiceTemplateDialogEdit({ commit, dispatch }, template) {
    dispatch('updateChoiceTemplate', template);

    commit(types.SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY, false);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE, false);
  },

  choiceTemplateShowEditDialog({ commit }, { template, choices }) {
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_FORM, template);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_CHOICES, choices);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY, true);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE, false);
  },

  choiceTemplateShowCreateDialog({ commit }, { choices, isScale = false }) {
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_CHOICES, choices);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY, true);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE, isScale);
  },

  choiceTemplateDialogCancel({ commit }) {
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY, false);
    commit(types.SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE, false);
  },

  questionCategoryDialogCreate({ commit, dispatch }, category) {
    dispatch('createQuestionCategory', category);

    commit(types.SET_QUESTION_CATEGORY_DIALOG_VISIBILITY, false);
  },

  choiceCategoryDialogCreate({ commit, dispatch }, category) {
    dispatch('createChoiceCategory', category);

    commit(types.SET_CHOICE_CATEGORY_DIALOG_VISIBILITY, false);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/actions.js